<div class="confirmation">
  <div class="confirmation__icon"></div>
  <div class="confirmation__title" i18n>Thank you!</div>
  <div class="confirmation__student">
    <div i18n>Hi {{ studentFirstName$ | async }}.</div>
    <div i18n>Your place is now guaranteed</div>
  </div>
  <div class="confirmation__title" i18n>What's next?</div>
  <div class="confirmation__advisor" i18n>
    You will shortly receive an email to confirm we have received your application as well as receipt of payment. Your
    {{ company | lxCompanyFormattedName }} adviser will be in touch to confirm the next step on your journey with {{ company | lxCompanyFormattedName }}.
  </div>
  <div class="confirmation__advisor" i18n>
    If you have any immediate questions, you can also <a class="confirmation__contact-link" [href]="contactLink">Contact an advisor</a> directly.
  </div>
  <div class="confirmation__footer">
    <lx-button tabindex="0" class="confirmation__footer__button" buttonStyle="primary" [block]="true" [btnRounded]="true" (buttonClick)="closeQuoteToolLite()">
      {{ backButtonLabel }}
    </lx-button>
  </div>
</div>
